import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export function useHaberler() {
  const [haberler, setHaberler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('haberler')
      .select('*')
      .order('sira', { ascending: true })
      .then(({ data, error }) => {
        if (!error && data) setHaberler(data);
        setLoading(false);
      });
  }, []);

  return { haberler, loading };
}

export function useEtkinlikler() {
  const [etkinlikler, setEtkinlikler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('etkinlikler')
      .select('*')
      .order('sira', { ascending: true })
      .then(({ data, error }) => {
        if (!error && data) setEtkinlikler(data);
        setLoading(false);
      });
  }, []);

  return { etkinlikler, loading };
}

export function useYayinlar() {
  const [yayinlar, setYayinlar] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('yayinlar')
      .select('*')
      .order('sira', { ascending: true })
      .then(({ data, error }) => {
        if (!error && data) setYayinlar(data);
        setLoading(false);
      });
  }, []);

  return { yayinlar, loading };
}

let _duyurularCache = null;

export function useDuyurular() {
  const [duyurular, setDuyurular] = useState(_duyurularCache || []);
  const [loading, setLoading] = useState(!_duyurularCache);

  useEffect(() => {
    if (_duyurularCache) return;
    supabase
      .from('duyurular')
      .select('id,title,summary,date,link,slug')
      .order('sira', { ascending: true })
      .then(({ data, error }) => {
        if (!error && data) {
          _duyurularCache = data;
          setDuyurular(data);
        }
        setLoading(false);
      });
  }, []);

  return { duyurular, loading };
}
